// Quarks
import { type FC } from 'react';

import checkIcon from 'assets/images/checkIcon.svg';

import Container from 'quarks/Container';
import Flex from 'quarks/Flex';
import Image, { ImageData } from 'quarks/Image';
import Text from 'quarks/Text';
import type { FlexProps } from 'quarks/interpolations/flex';

import richTextParser from 'utils/richTextParser';

import type { ContentfulElementListItem } from 'graphqlTypes';

interface ListItemProps extends FlexProps, ContentfulElementListItem {
  showIcon?: boolean;
}

const ListItem: FC<ListItemProps> = ({ id, icon, showIcon = true, heading, body, ...props }) => (
  <Flex gap="18px" alignItems="flex-start" key={id || 'List Item'} {...props}>
    {icon ? (
      <Container minWidth="18px" maxWidth="18px" minHeight="18px" maxHeight="18px" marginTop={4}>
        <Image image={icon as ImageData} alt={icon?.title || 'List Item Asset'} height="100%" width="100%" />
      </Container>
    ) : showIcon ? (
      <Container marginTop={4} minWidth="20px" maxWidth="20px" minHeight="20px" maxHeight="20px">
        <Image image={{ file: { url: checkIcon } }} alt="List Item Asset" height="100%" width="100%" />
      </Container>
    ) : (
      ''
    )}
    <Flex flexDirection="column" gap="8px">
      {heading && (
        <Text textStyle="textMd" fontWeight="bold">
          {heading}
        </Text>
      )}
      {body && (
        <Flex flexDirection="column" gap="16px" fontSize="textMd">
          {richTextParser(body)}
        </Flex>
      )}
    </Flex>
  </Flex>
);

export default ListItem;
